import React from 'react';

const Estatisticas = () => {
  const stats = [
    { label: "Notaram menos coceira", pct: 95 },
    { label: "Notaram menos lambedura das patas", pct: 90 },
    { label: "Notaram melhora das alergias", pct: 87 },
    { label: "Notaram menos queda de pelo e mais brilho", pct: 97 },
    { label: "Notaram mais disposição e imunidade", pct: 95 }
  ];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        
        <h2 style={styles.title}>
          O QUE VOCÊ PODE NOTAR AO DAR A GUMMY DIARIAMENTE PARA SEU PET?
        </h2>
        
        <p style={styles.subtitle}>
          Os tutores afirmam que:
        </p>

        <div style={styles.statsWrapper}>
          {stats.map((item, index) => (
            <div key={index} style={styles.statRow}>
              
              {/* Texto e Porcentagem */}
              <div style={styles.headerRow}>
                <span style={styles.statLabel}>{item.label}</span>
                <span style={styles.statPercent}>{item.pct}%</span>
              </div>

              {/* Barra de Progresso */}
              <div style={styles.barContainer}>
                <div style={{
                    ...styles.barFill,
                    width: `${item.pct}%` 
                }}></div>
              </div>

            </div>
          ))}
        </div>

        <div style={styles.disclaimer}>
            *Pesquisa realizada com clientes após 30 dias de uso contínuo.
        </div>

      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 20px',
    backgroundColor: '#fff',
    textAlign: 'center'
  },
  container: {
    maxWidth: '800px', // Mais estreito para focar nas barras
    margin: '0 auto'
  },
  title: {
    color: '#513D8B', // Roxo da marca
    fontSize: '2rem',
    marginBottom: '10px',
    lineHeight: '1.2',
    textTransform: 'uppercase'
  },
  subtitle: {
    color: '#666',
    fontSize: '1.2rem',
    fontFamily: '"Commissioner", sans-serif',
    marginBottom: '50px',
    fontWeight: '600'
  },
  statsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '25px'
  },
  statRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  statLabel: {
    color: '#333',
    fontSize: '1.1rem',
    fontFamily: '"Commissioner", sans-serif',
    fontWeight: '700',
    textAlign: 'left'
  },
  statPercent: {
    color: '#397449', // Verde destaque
    fontSize: '1.4rem',
    fontWeight: '900'
  },
  barContainer: {
    width: '100%',
    height: '20px',
    backgroundColor: '#E0E0E0',
    borderRadius: '10px',
    overflow: 'hidden'
  },
  barFill: {
    height: '100%',
    backgroundColor: '#397449', // Verde (Saúde)
    borderRadius: '10px',
    boxShadow: 'inset 0 2px 0 rgba(255,255,255,0.3)' // Brilho interno
  },
  disclaimer: {
    marginTop: '40px',
    fontSize: '0.8rem',
    color: '#999',
    fontStyle: 'italic'
  }
};

export default Estatisticas;